import { useCallback, useEffect, useState } from 'react';

const CLE_STOCKAGE = 'topformation:reduire-animations';
const CLASSE = 'reduire-animations';

function lireValeurInitiale(): boolean {
  try {
    return localStorage.getItem(CLE_STOCKAGE) === '1';
  } catch {
    return false;
  }
}

/**
 * Préférence de confort de lecture, propre à ce poste (comme les adaptations
 * d'accessibilité) : elle n'est ni envoyée à l'API, ni partagée entre comptes.
 */
export function useReduireAnimations(): [boolean, (valeur: boolean) => void] {
  const [actif, setActifEtat] = useState(lireValeurInitiale);

  useEffect(() => {
    document.body.classList.toggle(CLASSE, actif);
  }, [actif]);

  const setActif = useCallback((valeur: boolean) => {
    setActifEtat(valeur);
    try {
      localStorage.setItem(CLE_STOCKAGE, valeur ? '1' : '0');
    } catch {
      // Stockage indisponible (navigation privée) : la préférence reste pour la session en cours.
    }
  }, []);

  return [actif, setActif];
}
